import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatatableModule } from './datatable/datatable.module';
import { TablePipe } from './common/utils/table.pipe';

@NgModule({
  declarations: [TablePipe],
  imports: [
    CommonModule,
    DatatableModule,
    
  ],
  exports:[DatatableModule,TablePipe]
})
export class TableModule { }